import tableFeltUrl from '../assets/images/table-felt.png?url'
import rouletteWheelUrl from '../assets/images/roulette-wheel.webp?url'

export class AssetManager {
	private static loaded = false
	private static wheelImage: HTMLImageElement | null = null

	private static readonly assets = {
		tableFelt: tableFeltUrl,
		rouletteWheel: rouletteWheelUrl,
	} as const

	static get isLoaded() {
		return this.loaded
	}

	static getImageUrl(alias: keyof typeof AssetManager.assets) {
		return this.assets[alias]
	}

	static getWheelImage(): HTMLImageElement | null {
		return this.wheelImage
	}

	static async loadAll(onProgress?: (progress: number) => void) {
		if (this.loaded) {
			onProgress?.(1)
			return
		}

		const entries = Object.entries(this.assets)
		let completed = 0

		await Promise.all(
			entries.map(
				([key, src]) =>
					new Promise<void>((resolve) => {
						const image = new Image()
						image.onload = () => {
							if (key === 'rouletteWheel') {
								this.wheelImage = image
							}
							completed += 1
							onProgress?.(completed / entries.length)
							resolve()
						}
						image.onerror = () => {
							completed += 1
							onProgress?.(completed / entries.length)
							resolve()
						}
						image.src = src
					}),
			),
		)

		this.loaded = true
		onProgress?.(1)
	}
}
